import { call } from './../utilities/http';
import Answer from './../models/answer';
import {
    LOADING,
    COMPLETE,
    GET_FORMINSTANCE_QUESTIONS_OK,
    GET_FORMTYPE_QUESTIONS_OK,
    ANSWER_SAVE_OK,
    ONBOARDING_CREATE_CLASSIFICATION_OK,
    ONBOARDING_GET_CLASSIFICATION_OK,
    CLASSIFICATIONS_GET_ALL_OK,
    CLASSIFICATIONS_GET_REF_OK,
    CLASSIFICATIONS_GET_SCORE_OK,
    FORM_INSTANCE_UPDATE_OK,
    SAVING
} from './types';
import { Snackbar } from '../components/snackbar';

const defaultState = {
    classifications: undefined,
    list: undefined,
    draft: undefined,
    scores: undefined
};

/**
 * Loading state mapper.
 * @param {object} state
 * @param {string} action
 */
export default function(state = defaultState, action) {
    const questions = state.questions || [];
    switch (action.type) {
        case ANSWER_SAVE_OK:
            const updatedQs = questions.map(q => {
                const newAnswer = action.data.find(a => a.question_id === q.id);
                if (newAnswer) return { ...q, answer: newAnswer };
                else return q;
            });
            return { ...state, questions: updatedQs };

        case ONBOARDING_GET_CLASSIFICATION_OK:
            return { ...state, classification: action.data };

        case GET_FORMINSTANCE_QUESTIONS_OK:
        case GET_FORMTYPE_QUESTIONS_OK:
            if (action.id) {
                let data = {};
                data[action.id] = action.data;
                return { ...state, ...data };
            }
            return { ...state, questions: action.data };

        case ONBOARDING_CREATE_CLASSIFICATION_OK:
        case CLASSIFICATIONS_GET_ALL_OK:
        case CLASSIFICATIONS_GET_REF_OK:
            let classification = Array.isArray(action.data) ? action.data[0] : action.data;
            return { ...state, classification: classification };

        case CLASSIFICATIONS_GET_SCORE_OK:
            let data = {};
            data[action.id] = action.data;
            return { ...state, scores: state.scores ? { ...state.scores, ...data } : data };

        case FORM_INSTANCE_UPDATE_OK:
            let all = [...state.classifications];
            let updated = all.find(c => c.id === action.data.id);
            if (updated) {
                updated = action.data;
            }

            return { ...state, classifications: all };

        default:
            return state;
    }
}

export function getClassifications(formType, status = 'pending', onSuccess = response => null, onError = error => null) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/form_instance?form_type=${formType}&status=${status}` })
            .then(classifications => {
                let response;
                if (classifications.length > 0) {
                    const sortedClassifications = classifications.sort((a, b) => b.updated_at - a.updated_at);
                    response = sortedClassifications[0];
                }
                dispatch({ type: CLASSIFICATIONS_GET_ALL_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                dispatch({ type: COMPLETE });
                onError(error);
            });
    };
}

export function getRefClassifications(refId, refType, status = 'pending', onSuccess = response => null, onError = error => null) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/form_instance?ref_type=${refType}&ref_id=${refId}&status=${status}` })
            .then(classifications => {
                let response;
                if (classifications.length > 0) {
                    const sortedClassifications = classifications.sort((a, b) => b.updated_at - a.updated_at);
                    response = sortedClassifications[0];
                }
                dispatch({ type: CLASSIFICATIONS_GET_REF_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                dispatch({ type: COMPLETE });
                onError(error);
            });
    };
}

export function createNewClassification(formType, refId, refType, adminId, onSuccess = response => null, onError = error => null) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({
            path: '/form_instance',
            method: 'POST',
            body: { form_type: formType, ref_type: refType, ref_id: refId, admin_id: adminId }
        })
            .then(response => {
                dispatch({ type: ONBOARDING_CREATE_CLASSIFICATION_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                onError(error);
                dispatch({ type: COMPLETE });
            });
    };
}

export function getFormTypeQuestions(formType, adminId, positionId, onSuccess = response => null, onError = error => null) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/question?form_type=${formType}&admin=${adminId}&position=${positionId}` })
            .then(response => {
                dispatch({ type: GET_FORMTYPE_QUESTIONS_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                dispatch({ type: COMPLETE });
                onError(error);
            });
    };
}

export function getInstanceQuestions(formInstanceId, onSuccess = response => null, onError = error => null, storeBoundToId = false) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/form_instance/${formInstanceId}/answers?unanswered=true` })
            .then(response => {
                dispatch({ type: GET_FORMINSTANCE_QUESTIONS_OK, data: response, id: storeBoundToId ? storeBoundToId : undefined });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                dispatch({ type: COMPLETE });
                onError(error);
            });
    };
}

export function createClassification(jobId, adminId, onSuccess = response => null, onError = error => null) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({
            path: '/form_instance',
            method: 'POST',
            body: { form_type: 'job_classification_worker', ref_type: 'job', ref_id: jobId, admin_id: adminId }
        })
            .then(response => {
                dispatch({ type: ONBOARDING_CREATE_CLASSIFICATION_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                onError(error);
                dispatch({ type: COMPLETE });
            });
    };
}

export function getLatestPendingClassification(jobId, onSuccess = response => null, onError = error => null) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/form_instance?form_type=job_classification_worker&ref_type=job&ref_id=${jobId}&status=pending` })
            .then(classifications => {
                let response;
                if (classifications.length > 0) {
                    const sortedClassifications = classifications.sort((a, b) => b.updated_at - a.updated_at);
                    response = sortedClassifications[0];
                }
                dispatch({ type: ONBOARDING_GET_CLASSIFICATION_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                dispatch({ type: COMPLETE });
                onError(error);
            });
    };
}

export function saveAnswers(answers, onSuccess = () => null, onError = error => Snackbar.error(error)) {
    return function(dispatch) {
        if (!answers || answers.length === 0) {
            onSuccess();
            return;
        }

        let answerData = answers.map(a => new Answer(a));

        dispatch({ type: SAVING });
        return call({ path: `/answers`, method: 'POST', body: answerData })
            .then(answerResponse => {
                const answersWithIds = answers.map((a, i) => {
                    const id = answerResponse[i].id;
                    return { ...a, id };
                });
                dispatch({ type: ANSWER_SAVE_OK, data: answersWithIds });
                dispatch({ type: COMPLETE });
                onSuccess(answerResponse);
            })
            .catch(error => {
                dispatch({ type: COMPLETE });
                Promise.reject(error);
            });
    };
}

export function getJobQuestions(jobId, onSuccess = response => null, onError = error => null, storeBoundToId = false) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/job/${jobId}/questions` })
            .then(response => {
                dispatch({ type: GET_FORMINSTANCE_QUESTIONS_OK, data: response, id: storeBoundToId ? storeBoundToId : undefined });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                dispatch({ type: COMPLETE });
                onError(error);
            });
    };
}

export function getClassificationScore(formInstanceId, onSuccess = response => null, onError = error => null) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/form_instance/${formInstanceId}/score` })
            .then(response => {
                dispatch({ type: CLASSIFICATIONS_GET_SCORE_OK, data: response, id: formInstanceId });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                dispatch({ type: COMPLETE });
                onError(error);
            });
    };
}

export function updateFormInstance(instance, onSuccess = response => null, onError = error => null) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/form_instance/${instance.id}`, method: 'PUT', body: instance })
            .then(response => {
                dispatch({ type: FORM_INSTANCE_UPDATE_OK, data: instance });
                dispatch({ type: COMPLETE });
                onSuccess(instance);
            })
            .catch(error => {
                onError(error);
                dispatch({ type: COMPLETE });
            });
    };
}



// WEBPACK FOOTER //
// ./src/reducers/formInstances.jsx